module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/971bf35d25d66cfab7d186a28b596620.png";